import { checkResponse } from "../utils/checkResponse";
import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";
import jwt from "jsonwebtoken";

const serviceRole = {
  state: {
    serviceCode: "",
    userCode: "",
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    changeInfoServiceRole(state, payload) {
      state.serviceCode = payload.serviceCode;
      state.userCode = payload.userCode;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async findServiceRoleForAdmin(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceRoles/findServiceRoleForAdmin";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async findServiceRoleForSpa(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceRoles/findServiceRoleForSpa";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      // myHeaders.append('Content-Type', 'application/json');
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateModuleRole(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/serviceRoles/updateModule";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateModuleRoleOwner(payload = {}, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceRoles/updateModuleForOwner";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(
          _pick(payload, [
            "autoPaymentWallet",
            "paymentMethod",
            "expired",
            "paymentTypeCard",
            "package",
            "price",
            "moduleRole",
          ])
        ),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default serviceRole;
